export default __webpack_public_path__ + "static/media/performance_icon4.e1fcd807.svg";